module.exports = __webpack_public_path__ + "img/ico_hspx2@2x.c948a6b2.png";